module.exports = __webpack_public_path__ + "static/software-6686e216bff6febb28883dd7bc7fe1c1.mp4";